import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { req_single_rns_registerSpace } from '../../api'

import { Card } from 'antd'

import { addspace } from '../../utils/dataUtil'
import { CLIENT_URL } from '../../utils/contrains'
import QRCode from "react-qr-code";

class QrcodeModal extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    state = {
        loading: false,
        item: {}
    }

    static propTypes = {
        qc: PropTypes.string.isRequired
    }

    componentDidMount() {
        this.api_single_item()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
        const { token } = this.props.user
        const { qc } = this.props
        const result = await req_single_rns_registerSpace(qc, token)
        const item = result
        this.setState({ item })
    }

    render() {
        const { item } = this.state
        const { qc } = this.props
        const url = CLIENT_URL + '/footprint?space=' + qc
        const gridStyle = {
            width: '100%',
            textAlign: 'center',
        };
        return (
            <Card>
                <div style={gridStyle}><QRCode value={url} size="152" /></div>
                <p style={gridStyle}>{addspace(item.SpaceNumber + '', 4)}</p>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(QrcodeModal)